import { render, staticRenderFns } from "./LocalizedInput.vue?vue&type=template&id=78dbf523"
import script from "./LocalizedInput.vue?vue&type=script&lang=js"
export * from "./LocalizedInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports